import { Component, input } from '@angular/core';

@Component({
  standalone: true,
  selector: 'app-percent-03',
  imports: [],
  templateUrl: './percent-03.html',
  styleUrl: './percent-03.scss',
})
export class Percent03 {
  stroke = input('#797674');
  width = input('1rem');
  height = input('1rem');
}